export default __webpack_public_path__ + "static/media/404.796b53b7.svg";